/* ODES.MA — Theme JS v3.8 */
/* eslint-disable no-var */

(function () {
  'use strict';

  // Init-once guard — if theme.js gets injected twice (e.g. theme customizer
  // section re-render), all top-level handlers below would be bound twice,
  // causing duplicate adds on a single "Ajouter au panier" click.
  if (window.__odes_theme_inited) return;
  window.__odes_theme_inited = true;

  const ODES = (window.ODES = window.ODES || {});
  const $  = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));
  const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const supportsHover        = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  const money = (cents) => {
    try {
      return new Intl.NumberFormat('fr-MA', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'MAD' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toLocaleString('fr-MA') + ' DH';
    }
  };

  /* ------------------------------------------------------------------
   * Toast notifications
   * ------------------------------------------------------------------ */
  const toast = (msg, kind) => {
    const stack = $('#odes-toast-stack');
    if (!stack) return;
    const el = document.createElement('div');
    el.className = 'odes-toast' + (kind ? ' odes-toast--' + kind : '');
    el.setAttribute('role', 'status');
    el.textContent = msg;
    stack.appendChild(el);
    requestAnimationFrame(() => el.classList.add('is-visible'));
    setTimeout(() => {
      el.classList.remove('is-visible');
      setTimeout(() => el.remove(), 300);
    }, 3000);
  };
  ODES.toast = toast;

  /* ------------------------------------------------------------------
   * Viewport-height fix (rAF-throttled)
   * ------------------------------------------------------------------ */
  (function setVh() {
    let raf;
    const set = () => document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    set();
    window.addEventListener('resize', () => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(set);
    }, { passive: true });
  })();

  /* ------------------------------------------------------------------
   * Header scroll state
   * ------------------------------------------------------------------ */
  (function header() {
    const h = document.getElementById('odes-header');
    if (!h) return;
    const on = () => h.classList.toggle('is-scrolled', window.scrollY > 40);
    on();
    window.addEventListener('scroll', on, { passive: true });
  })();

  /* ------------------------------------------------------------------
   * Mobile navigation
   * ------------------------------------------------------------------ */
  (function mobileNav() {
    const burger = document.getElementById('odes-burger');
    const nav    = document.getElementById('odes-mobile-nav');
    const close  = document.getElementById('odes-mobile-close');
    if (!burger || !nav) return;

    const open = () => {
      nav.classList.add('is-open');
      burger.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      nav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const shut = () => {
      nav.classList.remove('is-open');
      burger.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      nav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    burger.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    nav.addEventListener('click', (e) => { if (e.target === nav) shut(); });

    // Mobile accordions
    $$('.odes-mobile-nav__acc').forEach((btn) => {
      btn.addEventListener('click', function () {
        const target = document.getElementById(this.dataset.target);
        const isOpen = this.classList.contains('is-open');
        $$('.odes-mobile-nav__acc').forEach((b) => b.classList.remove('is-open'));
        $$('.odes-mobile-nav__sub').forEach((s) => (s.style.maxHeight = '0'));
        if (!isOpen && target) {
          this.classList.add('is-open');
          target.style.maxHeight = target.scrollHeight + 'px';
        }
      });
    });
  })();

  /* ------------------------------------------------------------------
   * Hero slider — autoplay, dots, arrows, swipe, keyboard
   * ------------------------------------------------------------------ */
  (function heroSlider() {
    const hero = document.getElementById('odes-hero-slider');
    if (!hero) return;
    const slides = $$('.odes-hero__slide', hero);
    const dots   = $$('.odes-hero__dot', hero);
    if (slides.length <= 1) return;
    const autoplay = parseInt(hero.dataset.autoplay || '6000', 10);
    let current = 0;
    let timer = null;

    const goTo = (idx) => {
      slides[current].classList.remove('is-active');
      if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].removeAttribute('aria-current'); }
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-current', 'true'); }
    };
    const next = () => goTo(current + 1);
    const startTimer = () => {
      clearInterval(timer);
      if (!prefersReducedMotion) timer = setInterval(next, autoplay);
    };

    dots.forEach((d, i) => d.addEventListener('click', () => { goTo(i); startTimer(); }));
    const prevBtn = document.getElementById('odes-hero-prev');
    const nextBtn = document.getElementById('odes-hero-next');
    if (prevBtn) prevBtn.addEventListener('click', () => { goTo(current - 1); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { goTo(current + 1); startTimer(); });

    hero.addEventListener('mouseenter', () => clearInterval(timer));
    hero.addEventListener('mouseleave', startTimer);

    let touchStartX = 0;
    hero.addEventListener('touchstart', (e) => { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend',   (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) { dx < 0 ? goTo(current + 1) : goTo(current - 1); startTimer(); }
    }, { passive: true });

    // Keyboard: only when slider has focus or one of its buttons does
    hero.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { goTo(current - 1); startTimer(); }
      if (e.key === 'ArrowRight') { goTo(current + 1); startTimer(); }
    });
    hero.setAttribute('tabindex', '0');
    hero.setAttribute('aria-roledescription', 'carrousel');

    startTimer();
  })();

  /* ------------------------------------------------------------------
   * Scroll reveal (IntersectionObserver)
   * ------------------------------------------------------------------ */
  (function reveal() {
    const els = $$('.reveal');
    if (!('IntersectionObserver' in window) || prefersReducedMotion) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const sibs = entry.target.parentElement ? Array.from(entry.target.parentElement.querySelectorAll('.reveal')) : [];
        const idx  = sibs.indexOf(entry.target);
        const delay = Math.max(0, idx * 80);
        setTimeout(() => entry.target.classList.add('is-visible'), delay);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    els.forEach((el) => io.observe(el));
  })();

  /* ------------------------------------------------------------------
   * Product card 3D tilt (hover-only, reduced-motion-safe, rAF-throttled)
   * ------------------------------------------------------------------ */
  if (supportsHover && !prefersReducedMotion) {
    $$('.odes-product-card__img-wrap').forEach((card) => {
      let raf;
      card.addEventListener('mousemove', (e) => {
        const r = card.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width  - 0.5;
        const y = (e.clientY - r.top)  / r.height - 0.5;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          card.style.transition = 'transform 0.1s ease';
          card.style.transform  = `perspective(700px) rotateY(${x * 7}deg) rotateX(${-y * 7}deg) scale(1.02)`;
        });
      }, { passive: true });
      card.addEventListener('mouseleave', () => {
        if (raf) cancelAnimationFrame(raf);
        card.style.transition = 'transform 0.5s ease';
        card.style.transform  = 'perspective(700px) rotateY(0deg) rotateX(0deg) scale(1)';
      });
    });
  }

  /* ------------------------------------------------------------------
   * Page transition (delegated, light filters, prefers-reduced-motion)
   * ------------------------------------------------------------------ */
  (function pageTransition() {
    const overlay = $('.odes-page-transition');
    const enabled = document.body.dataset.pageTransition !== 'false';
    if (!overlay || !enabled || prefersReducedMotion) return;
    const DURATION = 250;
    const FILE_RE  = /\.(pdf|zip|jpg|jpeg|png|gif|webp|svg|mp4|mp3|csv|xlsx?)$/i;

    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const link = e.target.closest('a[href]');
      if (!link) return;
      const href = link.getAttribute('href');
      if (!href) return;
      if (link.hasAttribute('target') || link.hasAttribute('download') || link.hasAttribute('data-no-transition')) return;
      if (href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) return;
      if (/^https?:\/\//i.test(href) && link.host !== window.location.host) return;
      if (href.startsWith('/cart') || href.startsWith('/account') || href.startsWith('/admin') || href.startsWith('/checkout')) return;
      if (FILE_RE.test(href.split('?')[0])) return;

      e.preventDefault();
      overlay.style.transition      = `transform ${DURATION}ms cubic-bezier(0.76,0,0.24,1)`;
      overlay.style.transformOrigin = 'bottom';
      overlay.style.transform       = 'scaleY(1)';
      setTimeout(() => { window.location.href = href; }, DURATION);
    });

    window.addEventListener('pageshow', () => {
      overlay.style.transition      = 'transform 300ms cubic-bezier(0.76,0,0.24,1)';
      overlay.style.transformOrigin = 'top';
      overlay.style.transform       = 'scaleY(0)';
    });
  })();

  /* ------------------------------------------------------------------
   * Link prefetch on hover (uses <link rel="prefetch">)
   * ------------------------------------------------------------------ */
  (function prefetchOnHover() {
    if (document.body.dataset.prefetchEnabled === 'false') return;
    if (navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''))) return;
    const seen = new Set();
    const enqueue = (href) => {
      if (!href || seen.has(href)) return;
      seen.add(href);
      const link = document.createElement('link');
      link.rel = 'prefetch';
      link.href = href;
      document.head.appendChild(link);
    };
    document.addEventListener('mouseover', (e) => {
      const a = e.target.closest('a[href]');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || !href.startsWith('/')) return;
      if (a.hasAttribute('data-no-transition')) return;
      enqueue(href);
    }, { passive: true });
  })();

  /* ------------------------------------------------------------------
   * Cart — single source of truth for AJAX
   * ------------------------------------------------------------------ */
  const Cart = ODES.Cart = {
    async fetch() {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return r.json();
    },
    async add(formData) {
      const r = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
      if (!r.ok) throw await r.json();
      return r.json();
    },
    async change(line, quantity) {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      return r.json();
    }
  };

  const updateCartCount = (count) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  };

  const updateShippingBar = (totalCents) => {
    $$('[data-shipping-bar]').forEach((bar) => {
      const threshold = parseInt(bar.dataset.threshold || '0', 10);
      if (!threshold) return;
      const fill = bar.querySelector('[data-shipping-fill]');
      const msg  = bar.querySelector('[data-shipping-msg]');
      const pct  = Math.min(100, Math.round((totalCents / threshold) * 100));
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        if (totalCents >= threshold) {
          msg.classList.add('ocart__shipbar-msg--done');
          msg.innerHTML = '🎉 Livraison gratuite débloquée !';
        } else {
          msg.classList.remove('ocart__shipbar-msg--done');
          const remaining = threshold - totalCents;
          msg.innerHTML = 'Plus que <strong>' + money(remaining) + '</strong> pour la livraison gratuite !';
        }
      }
    });
  };

  const renderDrawerItems = (cart) => {
    const body = $('[data-cart-body]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="odes-drawer__empty">
          <p>Votre panier est vide.</p>
          <a href="/collections/all" class="odes-btn odes-btn--primary" data-drawer-close>Découvrir nos produits</a>
        </div>`;
      const foot = $('.odes-drawer__foot'); if (foot) foot.remove();
      return;
    }
    const itemsHtml = cart.items.map((item, i) => {
      const line = i + 1;
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="odes-drawer__item-variant">${item.variant_title}</p>` : '';
      const img = item.image ? `<img src="${item.image.replace(/(\.[^.]+)$/, '_160x$1')}" alt="${item.product_title}" width="80" height="80" loading="lazy">` : '';
      return `<li class="odes-drawer__item" data-line="${line}" data-key="${item.key}">
        <a href="${item.url}" class="odes-drawer__item-img" data-drawer-close>${img}</a>
        <div class="odes-drawer__item-body">
          <a href="${item.url}" class="odes-drawer__item-title" data-drawer-close>${item.product_title}</a>
          ${variant}
          <div class="odes-drawer__item-row">
            <div class="odes-drawer__qty">
              <button type="button" class="odes-drawer__qty-btn" data-cart-decrement data-line="${line}" aria-label="Diminuer">−</button>
              <input type="number" min="0" value="${item.quantity}" class="odes-drawer__qty-input" data-cart-qty data-line="${line}" aria-label="Quantité">
              <button type="button" class="odes-drawer__qty-btn" data-cart-increment data-line="${line}" aria-label="Augmenter">+</button>
            </div>
            <span class="odes-drawer__item-price">${money(item.final_line_price)}</span>
          </div>
          <button type="button" class="odes-drawer__item-remove" data-cart-remove data-line="${line}">Retirer</button>
        </div>
      </li>`;
    }).join('');
    body.innerHTML = `<ul class="odes-drawer__items">${itemsHtml}</ul>`;
    const total = $('[data-cart-total]'); if (total) total.textContent = money(cart.total_price);
  };

  const syncCartUI = async () => {
    const cart = await Cart.fetch();
    updateCartCount(cart.item_count);
    updateShippingBar(cart.total_price);
    renderDrawerItems(cart);
    return cart;
  };

  /* ------------------------------------------------------------------
   * Cart drawer open/close
   * ------------------------------------------------------------------ */
  const drawer = $('#odes-cart-drawer');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    syncCartUI();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    const open  = e.target.closest('[data-cart-open]');
    const close = e.target.closest('[data-drawer-close]');
    if (open)  { e.preventDefault(); openDrawer();  }
    if (close) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  // Defensive: force the drawer's "Finaliser ma commande" link to /cart even if
  // a third-party (Releasit, page-transition, etc.) tries to retarget it to
  // /checkout. Capture phase + stopImmediatePropagation guarantee we win.
  document.addEventListener('click', (e) => {
    const cta = e.target.closest('.odes-drawer__checkout');
    if (!cta) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/cart';
  }, true);

  /* ------------------------------------------------------------------
   * Variant commit — split into two operations on purpose:
   *
   *   setFormInputVariant: write the chosen id into <input name="id">. Safe by
   *   itself — Shopify reads the form input on submit. But Releasit's
   *   "+items in cart" mode watches this input AND ?variant= and auto-adds
   *   whatever it sees, so we ONLY mutate it when we explicitly want
   *   Releasit to sync (i.e. the user clicked Releasit's own Buy-Now).
   *
   *   setUrlVariant: push ?variant= into the address bar. Triggers the same
   *   Releasit watcher — same rule: only when Releasit's Buy-Now is clicked.
   *
   * For the theme's regular "Ajouter au panier" submit we DO NEITHER. The
   * submit handler builds FormData() and overrides the id field directly, so
   * the right variant reaches /cart/add.js without ever touching the live
   * input or URL. That's what eliminates the double-add.
   * ------------------------------------------------------------------ */
  const setFormInputVariant = (id) => {
    const sid = String(id);
    const form  = document.getElementById('odp-form');
    const input = form && form.querySelector('input[name="id"]');
    if (input && input.value !== sid) input.value = sid;
  };
  const setUrlVariant = (id) => {
    const sid = String(id);
    try {
      const url = new URL(window.location.href);
      if (url.searchParams.get('variant') !== sid) {
        url.searchParams.set('variant', sid);
        window.history.replaceState({}, '', url);
      }
    } catch (e) { /* ignore */ }
  };

  // Releasit Buy-Now triggers ONLY. The theme's own ATC button (#odp-add-cart)
  // is deliberately NOT in this list — that flow runs through the submit
  // handler below, which uses FormData override and never touches input/URL.
  const RELEASIT_TRIGGER_SELECTOR =
      '[class*="releasit"], [id*="releasit"],'
    + '[class*="rli-"], [id*="rli-"],'
    + '[class*="cod-form"], [class*="cod-button"], [class*="cod_button"],'
    + '[class*="buy-now"], [class*="buynow"],'
    + '[data-cod], [data-buy-now]';

  const onReleasitPreCommit = (e) => {
    if (!window.__odes_selected_variant_id) return;
    const target = e.target;
    if (!target || !target.closest) return;
    if (target.closest(RELEASIT_TRIGGER_SELECTOR)) {
      setFormInputVariant(window.__odes_selected_variant_id);
      setUrlVariant(window.__odes_selected_variant_id);
    }
  };
  document.addEventListener('mousedown',  onReleasitPreCommit, true);
  document.addEventListener('touchstart', onReleasitPreCommit, { capture: true, passive: true });

  /* ------------------------------------------------------------------
   * Safety net: dedupe /cart/add calls at the network layer.
   *
   * If Releasit (or any third-party) fires its own /cart/add for the same
   * user action in parallel with ours, swallow the second call so the user
   * still sees a single quantity in the cart. Matches the exact (variant id,
   * quantity) pair within an 800 ms window — distinct variants/qtys are
   * never affected.
   * ------------------------------------------------------------------ */
  (function dedupeCartAdds() {
    const ADD_URL_RE = /\/cart\/add(\.js)?($|\?)/;
    const lastByKey = new Map();

    const parseBody = (body) => {
      try {
        if (body instanceof FormData) {
          return { id: body.get('id'), qty: body.get('quantity') || '1' };
        }
        if (typeof body === 'string') {
          if (body.charAt(0) === '{') {
            const j = JSON.parse(body);
            return { id: j.id, qty: String(j.quantity || 1) };
          }
          const p = new URLSearchParams(body);
          return { id: p.get('id'), qty: p.get('quantity') || '1' };
        }
      } catch (e) { /* ignore */ }
      return { id: null, qty: '1' };
    };

    const isDuplicate = (id, qty) => {
      if (!id) return false;
      const key = id + ':' + qty;
      const now = Date.now();
      const last = lastByKey.get(key) || 0;
      if (now - last < 800) return true;
      lastByKey.set(key, now);
      return false;
    };

    if (typeof window.fetch === 'function') {
      const orig = window.fetch.bind(window);
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        if (ADD_URL_RE.test(url) && init && init.body) {
          const { id, qty } = parseBody(init.body);
          if (isDuplicate(id, qty)) {
            console.warn('[ODES] suppressed duplicate /cart/add (fetch) variant=' + id);
            return Promise.resolve(new Response('{}', {
              status: 200,
              headers: { 'Content-Type': 'application/json' }
            }));
          }
        }
        return orig(input, init);
      };
    }

    if (typeof window.XMLHttpRequest === 'function') {
      const Orig = window.XMLHttpRequest;
      const origOpen = Orig.prototype.open;
      const origSend = Orig.prototype.send;
      Orig.prototype.open = function (method, url) {
        this.__odes_url = url;
        return origOpen.apply(this, arguments);
      };
      Orig.prototype.send = function (body) {
        const url = this.__odes_url || '';
        if (ADD_URL_RE.test(url) && body) {
          const { id, qty } = parseBody(body);
          if (isDuplicate(id, qty)) {
            console.warn('[ODES] suppressed duplicate /cart/add (xhr) variant=' + id);
            // Fake a successful response so the caller's onload still fires.
            const self = this;
            setTimeout(function () {
              try {
                Object.defineProperty(self, 'readyState',   { value: 4,    configurable: true });
                Object.defineProperty(self, 'status',       { value: 200,  configurable: true });
                Object.defineProperty(self, 'responseText', { value: '{}', configurable: true });
                Object.defineProperty(self, 'response',     { value: '{}', configurable: true });
              } catch (e) { /* readonly props — ignore */ }
              if (typeof self.onreadystatechange === 'function') self.onreadystatechange();
              if (typeof self.onload === 'function') self.onload();
            }, 0);
            return;
          }
        }
        return origSend.apply(this, arguments);
      };
    }
  })();

  /* ------------------------------------------------------------------
   * AJAX add-to-cart
   * Capture phase (3rd arg `true`) + stopImmediatePropagation + an in-flight
   * lock + FormData id-override = single, deterministic /cart/add per click.
   * The form input itself is never modified, so Releasit's variant watcher
   * has nothing to react to.
   * ------------------------------------------------------------------ */
  let cartAddInFlight = false;
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ajax-add-form], form[action$="/cart/add"]');
    if (!form) return;
    if (form.dataset.noAjax) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (cartAddInFlight) return;
    cartAddInFlight = true;

    // Build FormData manually and override id from the in-memory selection
    // rather than mutating the live form input (which Releasit watches).
    const fd = new FormData(form);
    if (window.__odes_selected_variant_id) {
      fd.set('id', String(window.__odes_selected_variant_id));
    }

    const btn = form.querySelector('button[type=submit]');
    if (btn) btn.disabled = true;
    try {
      await Cart.add(fd);
      const cart = await syncCartUI();
      toast(`✓ Ajouté au panier (${cart.item_count})`, 'success');
      // Only open drawer for explicit add buttons, not for inline product page submission
      if (!form.id || form.id !== 'odp-form') openDrawer();
    } catch (err) {
      console.error('cart add failed', err);
      toast((err && err.description) || 'Erreur. Réessayez.', 'error');
    } finally {
      if (btn) btn.disabled = false;
      cartAddInFlight = false;
    }
  }, true);

  /* ------------------------------------------------------------------
   * Cart line item interactions (works on /cart and in drawer)
   * ------------------------------------------------------------------ */
  document.addEventListener('click', async (e) => {
    const inc = e.target.closest('[data-cart-increment]');
    const dec = e.target.closest('[data-cart-decrement]');
    const rem = e.target.closest('[data-cart-remove]');
    if (!inc && !dec && !rem) return;
    e.preventDefault();
    const trigger = inc || dec || rem;
    const line = parseInt(trigger.dataset.line, 10);
    if (!line) return;

    if (rem) {
      await Cart.change(line, 0);
    } else {
      // Find the qty input scoped to the same container
      const container = trigger.closest('.ocart__item, .odes-drawer__item');
      const input = container && container.querySelector('[data-cart-qty]');
      const current = input ? (parseInt(input.value, 10) || 1) : 1;
      const newQty = inc ? current + 1 : Math.max(0, current - 1);
      if (input) input.value = newQty;
      await Cart.change(line, newQty);
    }
    const cart = await syncCartUI();
    if (document.body.classList.contains('template-cart')) {
      // Re-render the cart page in place by replacing the items list section
      const fresh = await fetch(window.location.href).then((r) => r.text());
      const dom = new DOMParser().parseFromString(fresh, 'text/html');
      const newBody = dom.querySelector('.ocart');
      const oldBody = document.querySelector('.ocart');
      if (newBody && oldBody) oldBody.replaceWith(newBody);
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    const line = parseInt(input.dataset.line, 10);
    const qty  = Math.max(0, parseInt(input.value, 10) || 0);
    await Cart.change(line, qty);
    await syncCartUI();
  });

  /* ------------------------------------------------------------------
   * Wishlist persistence (localStorage)
   * ------------------------------------------------------------------ */
  const Wishlist = ODES.Wishlist = {
    key: 'odes_wishlist_v1',
    list() { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    has(handle) { return this.list().some((x) => x.handle === handle); },
    toggle(handle, title) {
      const items = this.list();
      const i = items.findIndex((x) => x.handle === handle);
      if (i >= 0) items.splice(i, 1); else items.push({ handle, title, addedAt: Date.now() });
      localStorage.setItem(this.key, JSON.stringify(items));
      this.render();
      return i < 0; // true if now in list
    },
    render() {
      const count = this.list().length;
      $$('[data-wishlist-count]').forEach((el) => { el.textContent = count; if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); });
      const handles = new Set(this.list().map((x) => x.handle));
      $$('[data-wishlist-toggle]').forEach((btn) => {
        const handle = btn.dataset.handle;
        const liked = handles.has(handle);
        btn.classList.toggle('is-liked', liked);
        btn.setAttribute('aria-pressed', liked ? 'true' : 'false');
      });
    }
  };
  Wishlist.render();
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    const added = Wishlist.toggle(btn.dataset.handle, btn.dataset.title || '');
    toast(added ? '♥ Ajouté à vos favoris' : 'Retiré de vos favoris');
  });

  /* ------------------------------------------------------------------
   * Recently viewed
   * ------------------------------------------------------------------ */
  const Recent = ODES.Recent = {
    key: 'odes_recent_v1',
    list() { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    push(handle) {
      if (!handle) return;
      let items = this.list().filter((x) => x !== handle);
      items.unshift(handle);
      items = items.slice(0, 12);
      localStorage.setItem(this.key, JSON.stringify(items));
    }
  };
  // On product pages, record the current product
  (function recordRecent() {
    const m = window.location.pathname.match(/^\/products\/([^\/?#]+)/);
    if (m) Recent.push(m[1]);
  })();
  // Render recently viewed strip if a host exists
  (async function renderRecent() {
    const host = $('[data-recently-viewed-grid]');
    if (!host) return;
    const section = host.closest('[data-recently-viewed-section]');
    const currentHandle = (window.location.pathname.match(/^\/products\/([^\/?#]+)/) || [])[1];
    const handles = Recent.list().filter((h) => h !== currentHandle).slice(0, 10);
    if (handles.length === 0) { if (section) section.remove(); return; }
    try {
      const cards = await Promise.all(handles.map(async (h) => {
        const r = await fetch('/products/' + h + '.js'); if (!r.ok) return '';
        const p = await r.json();
        const img = p.featured_image ? p.featured_image.replace(/(\.[^.]+)$/, '_600x$1') : '';
        return `<a class="odp-recent__card" href="/products/${p.handle}">
          <div class="odp-recent__img-wrap">${img ? `<img class="odp-recent__img" src="${img}" alt="${p.title}" loading="lazy" width="400" height="400">` : ''}</div>
          <div class="odp-recent__meta">
            <span class="odp-recent__name">${p.title}</span>
            <span class="odp-recent__price">${money(p.price)}</span>
          </div>
        </a>`;
      }));
      const filled = cards.filter(Boolean);
      if (filled.length === 0) { if (section) section.remove(); return; }
      host.innerHTML = filled.join('');
      if (section) section.removeAttribute('hidden');
    } catch (e) {
      console.warn('recently viewed failed', e);
      if (section) section.remove();
    }
  })();

  /* ------------------------------------------------------------------
   * Server-side recommendations: fetch fresh markup from Shopify
   * ------------------------------------------------------------------ */
  (async function recommendations() {
    const section = $('[data-product-recommendations]');
    if (!section) return;
    const productId = section.dataset.productId;
    const limit = section.dataset.limit || 8;
    try {
      const r = await fetch(`/recommendations/products.json?product_id=${productId}&limit=${limit}`);
      if (!r.ok) return;
      const data = await r.json();
      if (!data.products || data.products.length === 0) return;
      const track = section.querySelector('[data-recommendations-track]');
      if (!track) return;
      track.innerHTML = data.products.map((p) => {
        const img1 = p.featured_image ? p.featured_image.replace(/(\.[^.]+)$/, '_600x$1') : '';
        return `<div class="ocar__slide">
          <div class="odes-product-card" data-product-handle="${p.handle}">
            <a class="odes-product-card__img-link" href="${p.url}">
              <div class="odes-product-card__img-wrap">
                ${img1 ? `<img class="odes-product-card__img odes-product-card__img--primary" src="${img1}" alt="${p.title}" loading="lazy" width="600" height="600">` : ''}
                ${p.compare_at_price > p.price ? `<span class="odes-product-card__badge odes-product-card__badge--sale">–${Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price)}%</span>` : ''}
              </div>
            </a>
            <div class="odes-product-card__info">
              <a class="odes-product-card__name" href="${p.url}">${p.title}</a>
              <div class="odes-product-card__bottom">
                <div class="odes-product-card__prices">
                  <span class="odes-product-card__price">${money(p.price)}</span>
                  ${p.compare_at_price > p.price ? `<span class="odes-product-card__old">${money(p.compare_at_price)}</span>` : ''}
                </div>
              </div>
            </div>
          </div>
        </div>`;
      }).join('');
      track.dispatchEvent(new CustomEvent('odes:slides-changed', { bubbles: true }));
    } catch (e) { /* silent */ }
  })();

  /* ------------------------------------------------------------------
   * Predictive search (header)
   * ------------------------------------------------------------------ */
  (function predictive() {
    const panel = $('[data-search-panel]');
    if (!panel) return;
    const input   = $('[data-search-input]', panel);
    const results = $('[data-search-results]', panel);
    const openBtn = $('[data-search-toggle]');
    const closeBtn = $('[data-search-close]');
    const open = () => { panel.hidden = false; panel.setAttribute('aria-hidden', 'false'); openBtn && openBtn.setAttribute('aria-expanded', 'true'); setTimeout(() => input && input.focus(), 50); };
    const close = () => { panel.hidden = true;  panel.setAttribute('aria-hidden', 'true');  openBtn && openBtn.setAttribute('aria-expanded', 'false'); };
    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });

    let timer;
    if (input) {
      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (q.length < 2) { results.innerHTML = ''; return; }
        timer = setTimeout(async () => {
          try {
            const r = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
            const data = await r.json();
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (products.length === 0) {
              results.innerHTML = `<p class="odes-search-panel__empty">Aucun résultat pour « ${q} »</p>`;
              return;
            }
            results.innerHTML = products.map((p) => `
              <a href="${p.url}" class="odes-search-panel__result">
                ${p.image ? `<img src="${p.image}" alt="${p.title}" width="48" height="48" loading="lazy">` : ''}
                <span class="odes-search-panel__result-title">${p.title}</span>
                <span class="odes-search-panel__result-price">${p.price}</span>
              </a>`).join('') + `<a href="/search?q=${encodeURIComponent(q)}" class="odes-search-panel__more">Voir tous les résultats →</a>`;
          } catch (e) { /* ignore */ }
        }, 200);
      });
    }
  })();

  /* ------------------------------------------------------------------
   * Quick view modal
   * ------------------------------------------------------------------ */
  (function quickView() {
    const modal = $('#odes-quickview');
    if (!modal) return;
    const body  = $('[data-quickview-body]', modal);

    const open = async (handle) => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      body.innerHTML = '<div class="odes-quickview__loading">Chargement…</div>';
      try {
        const r = await fetch('/products/' + handle + '.js');
        const p = await r.json();
        const img = p.featured_image ? p.featured_image.replace(/(\.[^.]+)$/, '_900x$1') : '';
        const compare = p.compare_at_price > p.price ? `<span class="odp-info__old-price">${money(p.compare_at_price)}</span>` : '';
        body.innerHTML = `
          <div class="odes-quickview__grid">
            <div class="odes-quickview__media">${img ? `<img src="${img}" alt="${p.title}" width="600" height="600">` : ''}</div>
            <div class="odes-quickview__info">
              <h2 class="odes-quickview__title">${p.title}</h2>
              <div class="odes-quickview__price">
                <span class="odp-info__price">${money(p.price)}</span> ${compare}
              </div>
              <div class="odes-quickview__desc">${(p.description || '').slice(0, 300)}…</div>
              <form action="/cart/add" method="post" data-ajax-add-form>
                <input type="hidden" name="id" value="${p.variants[0] ? p.variants[0].id : ''}">
                <input type="hidden" name="quantity" value="1">
                <button type="submit" class="odes-btn odes-btn--primary" ${p.available ? '' : 'disabled'}>${p.available ? 'Ajouter au panier' : 'Épuisé'}</button>
                <a class="odes-btn odes-btn--outline" href="/products/${p.handle}">Voir le produit →</a>
              </form>
            </div>
          </div>`;
      } catch (e) {
        body.innerHTML = '<p>Impossible de charger le produit.</p>';
      }
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-quickview]');
      if (trigger) { e.preventDefault(); open(trigger.dataset.quickview); }
      if (e.target.closest('[data-quickview-close]')) close();
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  })();

  /* ------------------------------------------------------------------
   * Product page — gallery, variants, sticky bar (kept; consolidated)
   * ------------------------------------------------------------------ */
  (function productPage() {
    const gallery = document.getElementById('odp-gallery');
    if (!gallery) return;

    const thumbs = $$('.odp-gallery__thumb', gallery);
    const slides = $$('.odp-gallery__img-slide', gallery);
    let current  = 0;

    const goTo = (idx) => {
      slides[current].classList.remove('is-active');
      if (thumbs[current]) thumbs[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (thumbs[current]) thumbs[current].classList.add('is-active');
    };
    thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
    const prev = $('#odp-prev'); const next = $('#odp-next');
    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));

    // Hover zoom
    const imgWrap = $('#odp-img-wrap');
    if (imgWrap && supportsHover && !prefersReducedMotion) {
      imgWrap.addEventListener('mousemove', (e) => {
        const r = imgWrap.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width)  * 100;
        const y = ((e.clientY - r.top)  / r.height) * 100;
        const img = imgWrap.querySelector('.odp-gallery__img-slide.is-active .odp-gallery__img');
        if (img) img.style.transformOrigin = `${x}% ${y}%`;
      });
    }

    // Quantity
    const qty = $('#odp-qty-input');
    const minus = $('#odp-qty-minus'); const plus = $('#odp-qty-plus');
    if (minus) minus.addEventListener('click', () => { if (qty) qty.value = Math.max(1, parseInt(qty.value, 10) - 1); });
    if (plus)  plus.addEventListener('click',  () => { if (qty) qty.value = Math.min(10, parseInt(qty.value, 10) + 1); });

    // Variant swatches — DO NOT write the variant ID into the form's hidden input on click.
    // Releasit COD's "Buy current product + items in cart" mode watches that input and auto-syncs
    // any value change to the cart. To avoid that, we hold the selection in memory only,
    // then inject it into the form at the exact moment Add-to-cart or Buy-now is clicked (further below).
    const variantId = $('#odp-variant-id');
    const updateSelectedLabel = (idx, value) => {
      const tag = document.querySelector(`[data-selected-for="${idx}"]`);
      if (tag) tag.innerHTML = ' : <strong>' + value + '</strong>';
    };
    $$('.odp-swatch').forEach((sw) => {
      // Idempotent: skip if this swatch has already been wired up
      // (defends against Shopify section re-renders re-running this IIFE).
      if (sw.dataset.bound === '1') return;
      sw.dataset.bound = '1';
      sw.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (sw.classList.contains('is-sold-out')) return;
        const optionIdx = parseInt(sw.dataset.optionIndex, 10);
        $$('.odp-swatch[data-option-index="' + optionIdx + '"]').forEach((s) => s.classList.remove('is-active'));
        sw.classList.add('is-active');
        updateSelectedLabel(optionIdx, sw.dataset.value);

        if (!window.__odes_variants) return;
        const selected = {};
        $$('.odp-swatch.is-active').forEach((s) => { selected[s.dataset.optionIndex] = s.dataset.value; });
        const keys = ['option1', 'option2', 'option3'];
        const match = window.__odes_variants.find((v) => Object.entries(selected).every(([i, val]) => v[keys[i]] === val));
        if (!match) return;

        // IN-MEMORY ONLY — never touch the form input here.
        window.__odes_selected_variant_id = match.id;

        // Dispatch a passive `variant:change` event so any third-party app
        // (Releasit, GTM, pixel relays) that listens for variant updates can
        // refresh its internal state without us having to mutate the form
        // input or URL (which would trigger Releasit's auto-add watcher).
        try {
          document.dispatchEvent(new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant: match, productHandle: window.__odes_product_handle }
          }));
        } catch (e) { /* old browsers */ }

        // Update price + compare-at + sale badge
        const priceEl = $('[data-price]') || $('.odp-info__price');
        if (priceEl) priceEl.textContent = money(match.price);
        const cmpEl = $('[data-compare-price]');
        if (cmpEl) {
          if (match.compare_at_price && match.compare_at_price > match.price) {
            cmpEl.textContent = money(match.compare_at_price);
            cmpEl.style.display = '';
          } else {
            cmpEl.style.display = 'none';
          }
        }

        // Update CTA availability
        const btn = $('#odp-add-cart');
        const txt = btn && btn.querySelector('.odp-btn-cart__text');
        if (btn) btn.disabled = !match.available;
        if (txt) txt.textContent = match.available ? 'Ajouter au panier' : 'Épuisé';

        // Update SKU
        const skuEl = $('[data-sku]');
        if (skuEl && match.sku) skuEl.textContent = match.sku;

        // NOTE: do NOT push the variant ID into the URL on swatch click.
        // Releasit COD watches URL `?variant=` changes and auto-adds to cart.
        // We only sync the URL at the moment the user actually submits / clicks Buy.
        // (See injectSelectedVariant + mousedown handler higher up.)

        // If the chosen variant has its own image, swap the gallery main image to it
        if (match.featured_image && match.featured_image.src) {
          const slides = $$('.odp-gallery__img-slide');
          slides.forEach((s, i) => {
            const img = s.querySelector('img');
            if (img && img.src.indexOf(match.featured_image.src.split('?')[0].replace(/^https?:/, '').split('/').pop()) !== -1) {
              s.classList.add('is-active');
              slides.forEach((o, j) => { if (j !== i) o.classList.remove('is-active'); });
            }
          });
        }
      });
    });

    // Initialise the "selected: X" labels on first load
    $$('.odp-swatch.is-active').forEach((sw) => {
      updateSelectedLabel(parseInt(sw.dataset.optionIndex, 10), sw.dataset.value);
    });

    // Accordion
    $$('.odp-accordion__trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const target = btn.dataset.target;
        const bodyEl = document.getElementById('acc-' + target);
        const isOpen = btn.classList.contains('is-open');
        $$('.odp-accordion__trigger').forEach((b) => b.classList.remove('is-open'));
        $$('.odp-accordion__body').forEach((b) => b.classList.remove('is-open'));
        if (!isOpen && bodyEl) { btn.classList.add('is-open'); bodyEl.classList.add('is-open'); }
      });
    });

    // Sticky bar
    const sticky = $('#odp-sticky');
    if (sticky) {
      const onScroll = () => sticky.classList.toggle('is-visible', window.scrollY > 520);
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  })();

})();
